import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

// ui
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Switch } from '@material-ui/core';

// icon
import { DamIcon } from '../../../../assets/svg/Icon';

// components
import NavForm from '../../formcontrol/FormControl';
import DamLargeDataListRidContainer from './DamLargeDataListsRidContainer';
import DamLargeDataListEgatContainer from './DamLargeDataListsEgatContainer';

// style
import '../../styles.css';
import { globalStyle } from '../../../../global/style';

const useStyles = makeStyles(globalStyle);

// Tab function
function TabPanel(props) {
  const {
    children, value, index,
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}
const TabContainer = ({ children }) => (
  <Box component="div">
    {children}
  </Box>
);

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function DamLargeLists() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [useRuleCurve, setUseRuleCurve] = useState(true);

  const handleSwitchChange = (event) => {
    setUseRuleCurve(event.target.checked);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4} md={4}>
          <Box display="flex" alignItems="center">
            <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
              <DamIcon style={{ color: 'white' }} />
            </Box>
            <Box p={1}><Typography variant="h6" className={classes.titlePage}>{t('แหล่งน้ำขนาดใหญ่')}</Typography></Box>
          </Box>
        </Grid>
        <Grid item xs={12} sm={8} md={8}>
          <NavForm />
        </Grid>
      </Grid>

      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <Tabs value={value} onChange={handleChange} indicatorColor="primary" scrollButtons="auto" aria-label="simple tabs example">
          <Tab label={t('แหล่งน้ำขนาดใหญ่ กรมชลฯ')} id="tab-large-dam" aria-controls="tabpanel-0" className={value === 0 ? classes.active_tab : classes.tab} />
          <Tab label={t('แหล่งน้ำขนาดใหญ่ การไฟฟ้า')} id="tab-medium-dam" aria-controls="tabpanel-1" className={value === 1 ? classes.active_tab : classes.tab} />
        </Tabs>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Typography>ใช้เกณฑ์ rule curve</Typography>
          <Switch
            checked={useRuleCurve}
            onChange={handleSwitchChange}
          />
        </Box>
      </Box>

      <TabContainer component="div">
        <TabPanel value={value} index={0}>
          <DamLargeDataListRidContainer useRuleCurve={useRuleCurve} />
        </TabPanel>
      </TabContainer>

      <TabContainer component="div">
        <TabPanel value={value} index={1}>
          <DamLargeDataListEgatContainer useRuleCurve={useRuleCurve} />
        </TabPanel>
      </TabContainer>
    </div>
  );
}

TabPanel.defaultProps = {
  children: '',
};
